import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const FiltersBar = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
`;

export const StatsBar = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const StatCard = styled.div`
  background: ${props => props.$bgColor || '#f8fafc'};
  border: 1px solid ${props => props.$borderColor || '#e2e8f0'};
  border-radius: 8px;
  padding: 10px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
`;

export const StatValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${props => props.$color || COLORS.PRIMARY};
`;

export const StatLabel = styled.div`
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
  text-transform: uppercase;
`;

export const EmployeeRow = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #f1f5f9;
  gap: 16px;
  transition: background-color 0.15s;

  &:hover {
    background-color: #f8fafc;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const EmployeeInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 280px;
  min-width: 280px;
  flex-shrink: 0;
`;

export const EmployeeName = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${COLORS.PRIMARY};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EmployeeEmail = styled.div`
  font-size: 12px;
  color: #94A3B8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CertBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
  background-color: ${props => {
    switch (props.$status) {
      case 'expired': return '#FEE2E2';
      case 'expiring_soon': return '#FEF3C7';
      case 'valid': return '#D1FAE5';
      default: return '#F1F5F9';
    }
  }};
  color: ${props => {
    switch (props.$status) {
      case 'expired': return '#DC2626';
      case 'expiring_soon': return '#D97706';
      case 'valid': return '#059669';
      default: return '#64748B';
    }
  }};
`;

export const CertsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
`;

/**
 * Row holding the view toggle and the Export button.
 *
 * Export sits next to "what am I looking at" rather than among the filter
 * inputs, which it is not part of.
 */
export const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const ViewToggle = styled.div`
  display: flex;
  gap: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  width: fit-content;
`;

export const ExportButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  background: white;
  color: ${COLORS.PRIMARY};
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: #f1f5f9;
    border-color: #cbd5e1;
  }

  &:disabled {
    color: #94A3B8;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const ViewToggleButton = styled.button`
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.15s;
  background: ${props => props.$active ? COLORS.PRIMARY : 'white'};
  color: ${props => props.$active ? 'white' : '#64748B'};

  &:hover {
    background: ${props => props.$active ? COLORS.PRIMARY : '#f1f5f9'};
  }

  &:not(:last-child) {
    border-right: 1px solid #e2e8f0;
  }
`;

export const IssuerSection = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
`;

export const IssuerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #f8fafc;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background: #f1f5f9;
  }
`;

export const IssuerName = styled.div`
  font-weight: 600;
  font-size: 15px;
  color: ${COLORS.PRIMARY};
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const IssuerMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #64748B;
`;

export const CertSection = styled.div`
  border-top: 1px solid #f1f5f9;
`;

export const CertHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px 10px 40px;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background: #fafbfc;
  }
`;

export const CertName = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CertMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #94A3B8;
`;

export const TreeEmployeeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 8px 64px;
  border-top: 1px solid #f8fafc;
  transition: background-color 0.15s;

  &:hover {
    background-color: #fafbfc;
  }
`;

export const LoadMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  margin-top: 16px;
  border: 1px dashed #CBD5E1;
  border-radius: 8px;
  background: transparent;
  color: ${COLORS.PRIMARY};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #F8FAFC;
    border-color: ${COLORS.PRIMARY};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
